export default __webpack_public_path__ + "static/media/Pilgrim's Braid of Yag.2e8d2a12.jpg";